// src/components/img/GalerySectionVessels/VesselApolon.tsx
import React from 'react';
import vesselImage from './apolon.jpeg';

const VesselApolon: React.FC = () => (
  <img src={vesselImage} alt="Vessel Apolon" />
);

export default VesselApolon;